<template>
  <el-container>
    <el-header style="height:50px;">
      <div class="header-logo">
        <img src="../assets/logo.png" alt style="width:40px;display:none;" />
        <span>{{title}}</span>
      </div>
      <div class="header-menu">
        <HorizontalMenu :rootID="0" style="margin-right:10px;"></HorizontalMenu>
        <person-center></person-center>
      </div>
    </el-header>
    <el-container>
      <VerticalMenu v-if="leftMenuVisible"></VerticalMenu>
      <el-main>
        <div class="view-content">
          <transition name="fade-transform" mode="out-in">
            <router-view></router-view>
          </transition>
        </div>
      </el-main>
    </el-container>
  </el-container>
</template>
<script>
import Breadcrumb from "@/components/Menu/Breadcrumb";
import VerticalMenu from "../components/Menu/VerticalMenu";
import HorizontalMenu from "../components/Menu/HorizontalMenu";
import PersonCenter from "../components/Menu/Avatar";
export default {
  components: {
    Breadcrumb,
    VerticalMenu,
    HorizontalMenu,
    PersonCenter,
  },
  data() {
    return {
      title: _myconfig.title,
    };
  },
  methods: {},
  computed: {
    leftMenuVisible() {
      return this.$store.state.leftMenuVisible;
    },
  },
};
</script>
<style lang="less" scoped>
.el-container {
  height: 100%;
  width: 100%;
}
.el-main {
  padding: 0px;
  display: flex;
  flex-direction: column;
}

.el-header {
  background-color: #141414;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #fff;
  height: 50px;
}

.header-logo span {
  margin-left: 15px;
  font-size: 25px;
}
.header-logo {
  display: flex;
  align-items: center;
  height: 100%;
}
.header-menu {
  display: flex;
  align-items: center;
  height: 100%;
}
.view-content {
  flex: 1;
  height: 0;
  overflow: hidden;
}
</style>